export const MODIFICA_TOKEN = 'MODIFICA_TOKEN';
export const MODIFICA_NOME = 'MODIFICA_NOME';
export const MODIFICA_LOADER = 'MODIFICA_LOADER';


// WEBPACK FOOTER //
// ./src/actions/types.js